import React from "react";
import PropTypes from "prop-types";
//
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getAnalytics } from "firebase/analytics";
// component
import AuthListener from "./auth/AuthListener";
import FirestoreListener from "./firestore/FirestoreListener";
import RealtimeListener from "./realtime/RealtimeListener";
import StorageListener from "./storage/StorageListener";
// config
import firebaseConfig from "../../config/config.firebase";

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);
const analytics = getAnalytics(app);

const FirebaseLayer = ({ children }) => {
  AuthListener({ auth });
  FirestoreListener({});
  RealtimeListener({});
  StorageListener({});

  return children;
};

FirebaseLayer.propTypes = {
  children: PropTypes.node,
};

FirebaseLayer.defaultProps = {
  children: null,
};

export default FirebaseLayer;
